// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__box--cl6SL .ant-tag {
  margin: 0;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__breakLine--wYRel {
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__elipsis--QTK8F {
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__label--oG5OW {
  display: flex;
  flex-wrap: wrap;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__item--Fl4jx {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  max-width: 100%;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__item--Fl4jx > .src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__label--oG5OW {
  display: contents;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__wide--ezsKx {
  display: flex;
  align-items: last baseline;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__separator--uFxQ8 {
  white-space: pre-wrap;
}
.src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__multiple--UAKf3 {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/object/ObjectRefLabel/ObjectRefLabel.module.less"],"names":[],"mappings":"AAAA;EAEI,SAAA;AAAJ;AAGA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGA;EACE,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAIA;EACE,aAAA;EACA,eAAA;AAFF;AAKA;EACE,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAHF;AAME;EACE,iBAAA;AAJJ;AAQA;EACE,aAAA;EACA,0BAAA;AANF;AASA;EACE,qBAAA;AAPF;AAUA;EACE,WAAA;AARF","sourcesContent":[".box {\n  :global(.ant-tag) {\n    margin: 0;\n  }\n}\n.breakLine {\n  word-break: break-all;\n  white-space: normal;\n  overflow: hidden;\n}\n.elipsis {\n  text-overflow: ellipsis;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.label {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.item {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  max-width: 100%;\n\n  // Поля и разделитель — в одном потоке, разделитель остаётся после последнего поля.\n  & > .label {\n    display: contents;\n  }\n}\n\n.wide {\n  display: flex;\n  align-items: last baseline;\n}\n\n.separator {\n  white-space: pre-wrap;\n}\n\n.multiple {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__box--cl6SL`,
	"breakLine": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__breakLine--wYRel`,
	"elipsis": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__elipsis--QTK8F`,
	"label": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__label--oG5OW`,
	"item": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__item--Fl4jx`,
	"wide": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__wide--ezsKx`,
	"separator": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__separator--uFxQ8`,
	"multiple": `src-common-attributes-makeAttrLabel-labelMakers-object-ObjectRefLabel-ObjectRefLabel-module__multiple--UAKf3`
};
export default ___CSS_LOADER_EXPORT___;
